import { type NetworkType, WithSkeleton } from '@capsicum/common';
import { CardCarousel, Skeleton, SkeletonItem } from '@capsicum/common-web';
import { type MyNft } from '@capsicum/socios-core';
import { styled } from 'styled-components';

import { NftCard } from '../nft-card/NftCard';
import { NoNftsCard } from '../no-nfts-card/NoNftsCard';

type NftsComponentProps = {
	nfts: Array<MyNft>;
	onNftClick: (nftId?: string) => void;
};

export const NftsCarouselSkeleton = () => (
	<S.Container>
		<S.CardCarouselStyled
			arrowsVisible={false}
			cardWidth={143}
			disabled
			showHeader={false}
			testID="nc-wallet-nfts-carousel-skeleton"
		>
			<SkeletonItem height={227} width={173}></SkeletonItem>
			<SkeletonItem height={227} width={173}></SkeletonItem>
			<SkeletonItem height={227} width={173}></SkeletonItem>
			<SkeletonItem height={227} width={173}></SkeletonItem>
			<SkeletonItem height={227} width={173}></SkeletonItem>
			<SkeletonItem height={227} width={173}></SkeletonItem>
		</S.CardCarouselStyled>
	</S.Container>
);

const CarouselCard = ({ nft, onNftClick }: { nft: MyNft; onNftClick: (nftId?: string) => void }) => (
	<NftCard
		backgroundImageUrl={nft.partner?.rewardsBackground || ''}
		key={`${nft.summary?.collectibleId} ${nft.partner?.id}` || ''}
		network={nft.blockchain?.networkType as NetworkType}
		nftImageUrl={nft.summary?.imageUrl || ''}
		subtitle={nft.summary?.description || ''}
		title={nft.summary?.name || ''}
		onActivate={() => onNftClick(nft.summary?.collectibleId)}
	/>
);

const NftsComponent = ({ nfts, onNftClick }: NftsComponentProps) => {
	return nfts.length === 0 ? (
		<NoNftsCard />
	) : (
		<S.Container>
			<S.CardCarouselStyled
				arrowsVisible={false}
				cardWidth={173}
				showHeader={false}
				testID="nc-wallet-nfts-carousel"
			>
				{nfts.map((item, index) => (
					<CarouselCard
						key={item.partner?.id && item.partner?.id + index}
						nft={item}
						onNftClick={onNftClick}
					/>
				))}
			</S.CardCarouselStyled>
		</S.Container>
	);
};

export const NftsCarousel = WithSkeleton(NftsComponent, NftsCarouselSkeleton);

namespace S {
	export const Container = styled.div`
		width: 100%;
	`;
	export const CardCarouselStyled = styled(CardCarousel)`
		margin: 0;
		padding: 0;
	`;
	export const SkeletonStyled = styled(Skeleton)`
		flex-direction: row;
	`;
}
